import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import WeCanEdit from './home/WeCanEdit.js';
import EditTiersSection from './home/EditTiersSection.js';
import {Helmet} from "react-helmet";


const styles = {
    container: {
        width: '100%',
    },
    topPad: {
        height:'128px'
    },
    bottomPad: {
        height:'96px'
    },
    orange_blurb: {"position":"fixed","zIndex":"999","top":"0px","left":"0px","maxWidth":"90%","maxHeight":"95%","overflow":"auto","width":"600px","display":"none"},

}

class Home extends Component{
    componentDidUpdate() {
        setTimeout(function(){window.scrollTo(0, 0);}, 1200);
    }
    render() {
        return(
        <div className="home">
            <Helmet>
                <link rel="canonical" href="https://editmypaper.ca" />
            </Helmet>
            <TopNav/>
            <section className="steps top_section">
                <div className="steps-container" style={styles.container}>
                    <center>
                        <h1 className="flagsLine">
                            Comprehensive English, French, German, and Spanish essay editing!
                        </h1>
                    </center>
                </div>
                <div className="titlePage-wrap" id="home" style={{fontFamily:'quicksand'}}>
                    <div className="titlePage-wrap2">
                        <div className="titlePage" style={{minHeight: '312px'}}>
                            <div className="columns large-12 medium-12 small-12">
                                <center>
                                    <div style={styles.topPad} className="show-for-medium-up"></div>
                                    <h1 className="title"><span className="bold toggle" >WE EDIT ESSAYS</span></h1>
                                    <div style={styles.topPad} className="show-for-medium-up"></div>
                                    <a href="/get-started">
                                        <div className="big-btn large-9 medium-12 small-12">
                                           EDIT MY PAPER NOW!
                                        </div>
                                    </a>
                                    <div style={styles.bottomPad} className="show-for-medium-up"></div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="benefits" id="benefits" style={{fontFamily:'quicksand', backgroundColor:'rgb(0, 132, 193)', color: '#fff'}}>
                    <div className="columns">
                        <div style={{height:'32px'}}></div>
                        <h1 className="text-center">FAST AND ACCURATE PAPER EDITORS</h1>
                        <h3 className="text-center">SUBMIT YOUR ESSAY IN UNDER 3 MINUTES FOR EDITING</h3>
                        <h3 className="text-center">Your paper editor won't <i>just</i> proofread and edit <i>ANY</i>  English written work, they’ll tackle your: essay, manuscript, business report, assignment, dissertation, thesis, admission statement and resume to get you a better grade!</h3> <h3 className="text-center">Need something else? Contact us to receive a custom quote to have your <b>essay, thesis, dissertation or professional manuscript</b> edited by one of our select premium PhD manuscript editors.</h3>
                        <h2 className="text-center" style={{fontSize:'42px', fontFamily: 'quicksand bold'}}><i>Editing and Proofreading <u>All in One</u></i></h2>
                        <h2 className="text-center" style={{fontSize:'42px', fontFamily: 'quicksand bold'}}><i>Any Paper, Anytime </i></h2>
                        <h2 className="text-center" style={{fontSize:'42px', fontFamily: 'quicksand bold'}}>Get Your Paper Back in as Few as 90 Minutes!</h2>
                        <h3 className="text-center">Our paper editors are available 24/7</h3>


                        <div className="orange-blurb popup" tabIndex="1" style={styles.orange_blurb}>
                            <p className="text-right" style={{margin:'0'}}><a className="close-popup">X</a></p>
                            <p>Register with us to create your secure personal account. Upload your essay in .docx, .doc, .rtf, or .txt format
                            and input the word count as displayed by your word processor. Don't have a word processor? We also offer Google Docs editing. You can include any additional information for your editor to check within your document, such as your assignment's instructions.</p>
                        </div>
                        <div className="orange-blurb popup" tabIndex="2" style={styles.orange_blurb}>
                            <p className="text-right" style={{margin:'0'}}><a className="close-popup">X</a></p>
                            <p>Customize your editor: Choose an English/Social Science (or all subjects editor), Fine Arts, or Science editor. Choose the time you'd like to wait for your paper to be checked, from 90 minutes to 72 hours. Choose the level of your editor: Gold, Silver, or Bronze.</p>
                        </div>
                        <div className="orange-blurb popup" tabIndex="3" style={styles.orange_blurb}>
                            <p className="text-right" style={{margin:'0'}}><a className="close-popup">X</a></p>
                            <p>Once you have submitted and paid, you will receive an email containing your document when your paper has been completely edited. We GUARANTEE you will receive your paper back within the time you request. You'll also gain access to our exclusive markup guide which details exactly how you can accept, modify, or delete the edits and comments your editor has made. All editing is done using Track Changes via Microsoft Word.</p>
                        </div>
                        <div style={{height:'64px'}}></div>
                        <div className="process-icons">
                            <ul className="large-block-grid-5 medium-block-grid-3 small-block-grid-1">
                                <li className="hoverOpt" tabIndex="1">
                                    <center>
                                        <img src="images/home/b1.png"/>
                                        <h4 className="text-center">Upload Essay</h4>
                                    </center>
                                </li>
                                <li className="show-for-large-up">
                                    <center>
                                        <span className="large">&gt;</span>
                                    </center>
                                </li>
                                <div className="orange-blurb popup" style={styles.orange_blurb}>
                                <p>Customize your editor: Choose an English/Social Science (or all subjects editor), Fine Arts, or Science editor. Choose the time you'd like to wait for your paper, from 90 minutes to 72 hours. Choose the level of your editor: Gold, Silver, or Bronze.</p>
                                </div>
                                <li className="hoverOpt" tabIndex="2">
                                    <center>
                                        <img src="images/home/b2.png"/>
                                        <h4 className="text-center">Choose Editing Criteria</h4>
                                    </center>
                                </li>
                                <li className="show-for-large-up">
                                    <center>
                                        <span className="large">&gt;</span>
                                    </center>
                                </li>
                                <div className="orange-blurb popup" style={styles.orange_blurb}>
                                <p>Once you have submitted and paid, you will receive an email once your edited paper is ready. You'll gain access to our exclusive markup guide which details exactly how you can accept, modify, or delete the edits or comments your editor has made.</p>
                                </div>
                                <li className="hoverOpt" tabIndex="3">
                                    <center>
                                        <img src="images/home/b3.png"/>
                                        <h4 className="text-center">Download Edited Essay</h4>
                                    </center>
                                </li>
                            </ul>
                        </div>
                        <h3 className="text-center" style={{clear: 'both'}}>Remember, editing is <b>more</b> than just a light essay check and proofreading of your paper, it's making the corrections for you. Our experts will go above and beyond to impress you, which is why we check and fix your: spelling, grammar, punctuation, word choice, style, flow, and consistency issues. We also comment on areas that need more work.</h3>
                        <center>
                            <h3>
                                <a href="/edit-tiers">
                                    <span style={{color:'#7CFC00'}}>Still unsure about what our professional editors can do for you? Click here for examples of what our editing service can do for you.</span>
                                    <div style={{height:'32px'}}></div>
                                </a>
                                <center>
                                    <a href="/get-started">
                                        <div className="big-btn green-btn large-9 medium-12 small-12">
                                            EDIT MY PAPER NOW!
                                        </div>
                                    </a>
                                </center>
                                <div style={{height:'32px'}}></div>
                            </h3>
                        </center>
                    </div>
                </div>
                <div className="ourprocess-wrap" id="ourprocess">
                    <div className="ourprocess-wrap2">
                        <div className="">
                            <div className="columns large-12 medium-12 small-12" style={{width: '78%', margin: '0 auto'}}>
                                <div style={{height:'32px'}}></div>
                                    <h1 className="text-center">WHAT DO YOU MEAN BY 'EDIT'?</h1>
                                    <div style={{height:'32px'}}></div>
                                    <ul className="large-block-grid-3 medium-block-grid-1 small-block-grid-1 large-12 large-offset-0 medium-6 medium-offset-3">
                                        <li>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>spelling</h2>
                                            </div>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>grammar</h2>
                                            </div>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>correct your English</h2>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>word choice</h2>
                                            </div>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>flow improvements</h2>
                                            </div>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>consistency</h2>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>run-on sentences</h2>
                                            </div>
                                            <div className="point">
                                                <img src="images/home/checkmark.png"/>
                                                <h2>sentence fragments</h2>
                                            </div>
                                            <div className="point">
                                                <img src="images/home/checkmark.png" />
                                                <h2>punctuation</h2>
                                            </div>
                                        </li>
                                    </ul>
                                    <div style={{height:'11px'}}></div>
                                    <h3 style={{clear: 'both',}}className="text-center">Editors will find and <u>FIX</u> all of the types of issues listed above. Once we check your essay and you download your editor's copy, you'll see your edited paper along with comments on the side meant to guide you through additional improvements.</h3>
                                    <center><h3>We also offer additional services: extra comments, critiques, formatting, and extra essay checking/ESL editing.</h3></center>
                                    <center>
                                        <h3><a href="/edit-tiers"><span style={{color:'#7CFC00'}}>Click here to see what your essay editor will do for you.</span></a></h3>
                                        <div style={{height:'11px'}}></div>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <WeCanEdit></WeCanEdit>
                    <EditTiersSection></EditTiersSection>
                    <Footer></Footer>
            </section>
        </div>)
    }
}

export default connect(
)(Home);



// WEBPACK FOOTER //
// ./src/components/pages/Home.js